module.exports = __webpack_public_path__ + "static/img/tl_1@2x.e53c1db8.png";